import React from 'react';
import { Button } from 'antd';
import { closeManageSubscriptionModal } from 'utils/globalLayerControl';
import s from './s.module.less';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';

const MedicationSettings = (props: { isKlarityHealthJoined?: boolean, theme?: 'marketing' | 'default' }) => {
    const navigate = useNavigate();

    return (
        <div className={`${s.wrapper} ${props.theme === 'marketing' ? s.marketing : ''}`}>
            <div className={s.title}>Manage your visibility for medications shown on Klarity</div>
            <div className="mb-6">We may highlight medications in Klarity’s marketing content to help patients find the right care. These are linked to the conditions you treat — but you can opt out of any you don’t prescribe or prefer not to be included in.</div>
            <Button
                type="primary"
                onClick={() => {
                    navigate(`${PATH.MEDICATION_SETTINGS}`);
                    closeManageSubscriptionModal();
                }}
            // disabled={!props?.isKlarityHealthJoined}
            >
                Manage
            </Button>
        </div>
    );
};

export default MedicationSettings;
